import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";

const OnboardingGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated && user) {
      // Check if personalDetails exists (safety check)
      const isOnboardingComplete =
        user.personalDetails?.isOnboardingComplete ?? false;
      const userRole = user.profile?.role || user.role || "user";

      // If user is authenticated and onboarding is not completed
      // Redirect to onboarding page (except if already on onboarding page)
      if (
        isOnboardingComplete === false &&
        userRole === "user" &&
        location.pathname !== "/onboarding"
      ) {
        console.log("Redirecting to onboarding - onboarding not completed");
        navigate("/onboarding", { replace: true });
      }

      // If onboarding is completed and user is on onboarding page
      // Redirect to home
      if (
        isOnboardingComplete === true &&
        location.pathname === "/onboarding"
      ) {
        console.log("Redirecting to home - onboarding already completed");
        navigate("/", { replace: true });
      }
    }
  }, [user, isAuthenticated, location.pathname, navigate]);

  return children;
};

export default OnboardingGuard;
